//- Automatically import every scripts
import './scripts/**/*.js';